import Swiper from 'swiper';
import 'remodal';

// ナビゲーションアニメーション
const funcNav = () => {
	const areas = document.querySelectorAll('.area');
	const navItems = document.querySelectorAll('.side nav li');
	if (!areas.length || !navItems.length) return;

	const areasArray = [...areas];
	const check = (entries) => {
		entries.forEach((entry) => {
			const index = areasArray.indexOf(entry.target);
			if (index === -1) return;

			if (entry.isIntersecting) {
				navItems.forEach((item) => item.classList.remove('active'));
				if (navItems[index]) navItems[index].classList.add('active');
			} else {
				if (navItems[index]) navItems[index].classList.remove('active');
			}
		});
	};

	const options = {
		rootMargin: '0px 0px -90% 0px',
		threshold: 0,
	};

	const observer = new IntersectionObserver(check, options);
	areas.forEach((target) => observer.observe(target));
};

// スクロールアニメーション
const funcAnim = () => {
	const items = document.querySelectorAll('.anim');
	if (!items.length) return;

	const check = () => {
		const th = window.innerHeight * 0.9;
		items.forEach((el) => {
			if (el.classList.contains('active')) return;
			const r = el.getBoundingClientRect();
			if (r.top < th && r.bottom > 0) el.classList.add('active');
		});
	};

	check();
	if (document.readyState !== 'complete') {
		window.addEventListener('load', check, { once: true });
	}
	window.addEventListener('scroll', check, { passive: true });
	window.addEventListener('resize', check);
};

// TOPへ戻るボタン（.brand通過後に表示 / アプリ版は .pagetop 未設置のため非発火）
const funcPagetop = () => {
	const btn = document.querySelector('.pagetop');
	const brand = document.querySelector('#brand');
	const link = document.querySelector('.link');
	if (!btn || !brand) return;

	const check = () => {
		// #brand の上端を通過したら表示
		const passed = brand.getBoundingClientRect().top < 0;
		// .link（footer）がビューポートに入ったら消す
		const atLink = link && link.getBoundingClientRect().top < window.innerHeight;
		btn.classList.toggle('is-show', passed && !atLink);
	};

	btn.addEventListener('click', (e) => {
		e.preventDefault();
		window.scrollTo({ top: 0, behavior: 'smooth' });
	});

	check();
	window.addEventListener('scroll', check, { passive: true });
	window.addEventListener('resize', check);
};

// スムーススクロール
const easeInOut = (t) => (t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1);
const duration = 500;

window.addEventListener('DOMContentLoaded', () => {
	const triggers = document.querySelectorAll('.anchor');
	const areas = document.querySelectorAll('.area');
	const navItems = document.querySelectorAll('.side nav li');
	const areasArray = [...areas];

	triggers.forEach((trigger) => {
		trigger.addEventListener('click', (e) => {
			const href = trigger.getAttribute('href');
			if (!href || !href.startsWith('#')) return;

			const targetId = href.slice(1);
			if (!targetId) return;

			const targetElement = document.getElementById(targetId);
			if (!targetElement) return;

			e.preventDefault();
			e.stopPropagation();

			const currentPosition = window.scrollY || 0;
			const targetPosition = currentPosition + targetElement.getBoundingClientRect().top - 0;
			const distance = targetPosition - currentPosition;
			const startTime = performance.now();

			const loop = (nowTime) => {
				const time = nowTime - startTime;
				const normalizedTime = time / duration;

				if (normalizedTime < 1) {
					window.scrollTo(0, currentPosition + distance * easeInOut(normalizedTime));
					requestAnimationFrame(loop);
				} else {
					window.scrollTo(0, targetPosition);

					// funcNav等要素を取る時（発火位置調整）
					setTimeout(() => {
						const index = areasArray.indexOf(targetElement);
						if (index !== -1 && navItems[index]) {
							navItems.forEach((item) => item.classList.remove('active'));
							navItems[index].classList.add('active');
						}
					}, 100); // IntersectionObserverの更新を待つ
				}
			};

			requestAnimationFrame(loop);
		});
	});

	// スライダー
	const slides = document.querySelectorAll('.slide');
	slides.forEach((slide) => {
		const swiper = slide.querySelector('.swiper-container');
		if (!swiper) return;
		const pagination = slide.querySelector('.swiper-pagination');
		const nextButton = slide.querySelector('.swiper-button-next');
		const prevButton = slide.querySelector('.swiper-button-prev');
		new Swiper(swiper, {
			// effect: 'fade',
			// fadeEffect: {
			//   crossFade: true
			// },
			loop: true,
			spaceBetween: 20,
			// watchOverflow: true, // loopと併用不可
			speed: 1000,
			autoplay: {
				delay: 3000,
				disableOnInteraction: false,
				waitForTransition: false,
			},
			pagination: {
				el: pagination,
				type: 'bullets',
				clickable: true,
			},
			navigation: {
				nextEl: nextButton,
				prevEl: prevButton,
			},
		});
	});

	// スクロールアニメーション;
	funcAnim();

	// ナビゲーションアニメーション;
	funcNav();

	// TOPへ戻るボタン;
	funcPagetop();
});
